import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';


@Injectable()
export class TimeoutService {
  idleTime = environment.idleTimeout; 

  constructor() { }

  handleInactivity() {
    return new Observable(observer => {
      let timeout;

      const setInactive = () => {
        resetTimer
        observer.next(true);
      };

      const resetTimer = () => {
        clearTimeout(timeout);
        timeout = setTimeout(setInactive, this.idleTime);
        //console.log("timeout has been reset");
      };

      window.onload = resetTimer;
      document.onmousemove = resetTimer;
      document.onmousedown = resetTimer;
      document.onkeydown = resetTimer;
      document.onscroll = resetTimer;
      document.ontouchstart = resetTimer;
      document.ontouchmove = resetTimer;
      document.onmouseover = resetTimer;
    });
  }

  setIdleTime(idleTime: number) {
    this.idleTime = idleTime;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/timeout/timeout.service.ts